import React, { Component } from 'react';
import CertMoralInspectionFormModel from "../../models/certmoralinspectionform";
import {enumYesNoGenesis,enumFinalResult,enumYesNo} from "../../constants/enum.constants";
import EnumRadioInput from "../../helpers/enumRadioInput";
import GeoLocation from "./geolocation";
import BDateInput from '../../helpers/bdate-input'
import moment from 'moment-jalaali';

import 'rc-time-picker/assets/index.css';

import TimePicker from 'rc-time-picker';

const format = 'h:mm a';

const now = moment().hour(0).minute(0);

class CertReqMoralInspectionFormPartial extends Component {
    constructor(props) {
        super(props);
       
        this.state={
            model:new CertMoralInspectionFormModel(this.refs)
        }
        
        this.refreshModel=this.refreshModel.bind(this);
        this.refreshText=this.refreshText.bind(this);
        this.submit=this.submit.bind(this);  
        this.handleDeathDateChange=this.handleDeathDateChange.bind(this);
        this.handleInspectionDateChange=this.handleInspectionDateChange.bind(this);
        this.onDeathTimeChange=this.onDeathTimeChange.bind(this);
        this.handleCheckBox=this.handleCheckBox.bind(this);
     
    }

    componentDidMount()
    {
        let model=new CertMoralInspectionFormModel(this.refs);


        this.setState({
            model:model
        })
        if(this.props.form!=null)
        {
            model=this.props.form;
            this.setState({
                model:model
            })
        }

    }

    refreshModel (value=null,event) {
        var name=event.target.name;
       // let _model = new CertMoralFormModel(this.refs);  

        const {model}= this.state;
        model[name]=value;

        this.setState({

            model:model

        });

        console.log('MODEL9',model);    
    }

    refreshText(event) {
        const {model}= this.state;
        var name=event.target.name;
        var value=event.target.value;
        model[name]=value;

        this.setState({

            model:model

        });

        console.log('MODEL8',model);    
    }

    handleCheckBox(event) {
        const {model}= this.state;
        var name=event.target.name;
       
        model[name]=!model[name];

        this.setState({

            model:model

        });

        console.log('MODEL8',model);    
    }

    onDeathTimeChange(value)
    {
        
        const{model}=this.state;
        if(model)
        {
               model.DeathTime=value;
                this.setState({
                    model:model
                });
            
        }
    }
   
    handleDeathDateChange(e)
    {
        let datetime=this.refs.DateDeath.value;
        const{model}=this.state;
        if(model)
        {
               model.DateDeath=datetime;
                this.setState({
                    model:model
                });
            
        }
    }
    handleInspectionDateChange(e)
    {
        let datetime=this.refs.DateInspection.value;
        const{model}=this.state;
        if(model)
        {
               model.DateInspection=datetime;
                this.setState({
                    model:model
                });
            
        }
    }


    submit(){
        const {model}= this.state;

        let viewmodel= {
            Id:model.Id,
            FormType:2, // moral inspection formtype,
            LegalForm: null,
            MoralForm:null,
            MoralInspectionForm:model
        }

        this.props.submitCertFormHandler(viewmodel);
      
      }


    render() { 


        const {form} = this.props;
        const {model} = this.state;
        console.log('MMMMODELLLLL',model)
        return (  

            <div>
                                   
                <div className="row">
                <div className="col-md-12">
                    <div className="panel panel-default">
                        
                            <div className="toolbox">

                                <button type="button"  className="btn btn-default btn-sm" onClick={this.submit} ><i className="fa fa-save"></i>   ثبت اطلاعات
                                
                                </button>
                            
                            </div>
                        </div>
                </div>
                    
                    <div className="col-md-6">
                    
                        <input type="hidden" value={form && form.Id}></input>
                        <fieldset><legend>توصیف و وضعیت ظاهری</legend>
                        <div className="form-group">
                            <label>
                            توصیف و وضعیت ظاهری و مشخصات البسه   &nbsp;
                            </label>
                            <input  className="form-control" value={model && model.PresentationAndDressDescription} ref="PresentationAndDressDescription"  name="PresentationAndDressDescription" onChange={this.refreshText} type="text" />      
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                            <div className="form-group">
                                <label>
                                   سن   &nbsp;
                                </label>
                                <input  className="form-control" value={model && model.Age} ref="Age"  name="Age" onChange={this.refreshText} type="text" />      
                                </div>
                                <div className="form-group">
                                <label>
                                        
                                        قد   &nbsp;
                                        </label>
                                        <input  className="form-control" value={model && model.Height} ref="Height"  name="Height" onChange={this.refreshText} type="text" /> 
                                </div>
                                <div className="form-group">
                                <label>
                                   وزن   &nbsp;
                                </label>
                                <input  className="form-control" value={model && model.Weight} ref="Weight" name= "Weight"  type="text" onChange={this.refreshText} />
                                </div>
                            </div>
                            <div className="col-md-6">
                            <div className="form-group">
                                <label>
                                   دورسر (اطفال و نوزادان)   &nbsp;
                                </label>
                                <input  className="form-control" value={model && model.HeadEnv} ref="HeadEnv" name= "HeadEnv"  type="text" onChange={this.refreshText}/>
                                </div>
                                <div className="form-group">
                                        <label>
                                        دور سینه   &nbsp;
                                        </label>
                                        <input  className="form-control" value={model && model.BreastEnv} ref="BreastEnv" name= "BreastEnv"  type="text" onChange={this.refreshText}/>
                                </div>
                            </div>
                        </div>

                        
                      
                        
                        </fieldset>
                        <fieldset><legend>مشخصات جسد</legend>
                        <div className="form-group">
                            <label>
                            کبودی نعش   &nbsp;
                            </label>
                            <EnumRadioInput enumObj={enumYesNoGenesis} value={model && model.HasCorpseBruises} name="HasCorpseBruises" ref="HasCorpseBruises" onChange={this.refreshModel}></EnumRadioInput>
                        </div>
                       <div className="row">
                           <div className="col-md-6">
                                <div className="form-group">
                                    <label>
                                    رنگ کبودی   &nbsp;
                                    </label>
                                    <input  className="form-control" value={model && model.BruisesColor} ref="BruisesColor"  name="BruisesColor" onChange={this.refreshText} type="text" />      
                                </div>
                       
                           </div>
                           <div className="col-md-6">
                           
                                <div className="form-group">
                                        <label>
                                        محل کبودی   &nbsp;
                                        </label>
                                        <input  className="form-control" value={model && model.BruisesPlace} ref="BruisesPlace"  name="BruisesPlace" onChange={this.refreshText} type="text" />      
                                </div>
                           </div>
                       </div>

                       <div className="row">
                           <div className="col-md-6">
                           <div className="form-group">
                                <label>
                                جمود نعشی   &nbsp;
                                </label>
                                <br></br>
                                <EnumRadioInput enumObj={enumYesNoGenesis} value={model && model.HasCorpseSolidity} name="HasCorpseSolidity" ref="HasCorpseSolidity" onChange={this.refreshModel}></EnumRadioInput>
                            </div>
                       
                           </div>
                           <div className="col-md-6">
                                <div className="form-group">
                                    <label>
                                    محل جمود   &nbsp;
                                    </label>

                                    <input  className="form-control" value={model && model.SolidityPlace} ref="SolidityPlace"  name="SolidityPlace" onChange={this.refreshText} type="text" />      
                                </div>
                              
                           </div>
                       </div>

                       <div className="row">
                           <div className="col-md-6">
                           <div className="form-group">
                            <label>
                            فساد نعشی   &nbsp;
                            </label>
                            <br></br>
                            <EnumRadioInput enumObj={enumYesNo} value={model && model.CorpseCorruption} name="CorpseCorruption" ref="CorpseCorruption" onChange={this.refreshModel}></EnumRadioInput>
                            </div>
                       
                           </div>
                           <div className="col-md-6">
                           <div className="form-group">
                                <label>
                                   توضیحات فساد نعشی   &nbsp;
                                </label>
                                <input  className="form-control" value={model && model.CorpseCorruptionDesc} ref="CorpseCorruptionDesc"  name="CorpseCorruptionDesc" onChange={this.refreshText} type="text" />      
                            </div>
                           </div>
                       </div>
                        
                       
                       
                     
                       
                        </fieldset>

                        <fieldset><legend>زمان معاینه و فوت</legend>

                        <div className="row">
                           <div className="col-md-6">
                           <div className="form-group">
                                <label>
                               تاریخ فوت   &nbsp;
                                </label>
                                <BDateInput
                                    className="form-control"
                                    ref="DateDeath" 
                                    value={moment(model.DateDeath).isValid()?  model.DateDeath:moment() } 
                                    onChange={this.handleDeathDateChange}                               
                                />
                            </div>
                           </div>
                           <div className="col-md-6">
                           <div className="form-group">
                                <label>
                               تاریخ معاینه   &nbsp;
                                </label>
                                <BDateInput
                                    className="form-control"
                                    ref="DateInspection" 
                                    value={moment(model.DateInspection).isValid()?  model.DateInspection:moment() } 
                                    onChange={this.handleInspectionDateChange}                               
                                />
                            </div>
                              
                           </div>
                       </div>

                       <div className="row">
                           <div className="col-md-6">
                           <div className="form-group">
                                <label>
                               زمان تقریبی فوت   &nbsp;
                                </label>
                                <br></br>
                                <TimePicker
                                    showSecond={false}
                                    defaultValue={model.DeathTime || now}
                                    className=""
                                    onChange={this.onDeathTimeChange}
                                    format={format}
                                    use12Hours
                                    inputReadOnly
                                />
                            </div>
                           </div>
                           <div className="col-md-6">
                           
                              
                           </div>
                       </div>


                           
                         
                        </fieldset>
                        <fieldset>
                            <legend>پرونده بیمارستانی</legend>

                        <div className="row">
                           <div className="col-md-6">
                           <div className="form-group">
                                <label>
                               پرونده بیمارستانی و مدارک بالینی   &nbsp;
                                </label>
                                <br></br>
                                <EnumRadioInput enumObj={enumYesNo} value={model && model.HasPatientRecord} name="HasPatientRecord" ref="HasPatientRecord" onChange={this.refreshModel}></EnumRadioInput>
                            
                            </div>
                           </div>
                           <div className="col-md-6">
                           <div className="form-group">
                                <label>
                               نتیجه   &nbsp;
                                </label>
                                <input  className="form-control" value={model && model.PatientRecordResult} ref="PatientRecordResult"  name="PatientRecordResult" onChange={this.refreshText} type="text" />      
                            </div>
                              
                           </div>
                        </div>
                        
                        </fieldset>
                   
                    </div> 

                     <div className="col-md-6">
                        

                        <fieldset>
                            <legend>آثار ظاهری ضرب و جرح، سوختگی و ... با ذکر زمان حدوث</legend>

                        <div className="row">
                           <div className="col-md-6">
                           <div className="form-group">
                                <label>
                               سر و صورت   &nbsp;
                                </label>
                                <br></br>
                                <EnumRadioInput enumObj={enumYesNo} value={model && model.HeadFaceProb} name="HeadFaceProb" ref="HeadFaceProb" onChange={this.refreshModel}></EnumRadioInput>
                            
                            </div>
                           </div>
                           <div className="col-md-6">
                           <div className="form-group">
                                <label>
                               توضیحات   &nbsp;
                                </label>
                                <input  className="form-control" value={model && model.HeadFaceProbDesc} ref="HeadFaceProbDesc"  name="HeadFaceProbDesc" onChange={this.refreshText} type="text" />      
                            </div>
                              
                           </div>
                        </div>

                        <div className="row">
                           <div className="col-md-6">
                           <div className="form-group">
                                <label>
                               گردن   &nbsp;
                                </label>
                                <br></br>
                                <EnumRadioInput enumObj={enumYesNo} value={model && model.NeckProb} name="NeckProb" ref="NeckProb" onChange={this.refreshModel}></EnumRadioInput>
                            
                            </div>
                           </div>
                           <div className="col-md-6">
                           <div className="form-group">
                                <label>
                               توضیحات   &nbsp;
                                </label>
                                <input  className="form-control" value={model && model.NeckProbDesc} ref="NeckProbDesc"  name="NeckProbDesc" onChange={this.refreshText} type="text" />      
                            </div>
                              
                           </div>
                        </div>

                        <div className="row">
                           <div className="col-md-6">
                           <div className="form-group">
                                <label>
                               قدام تنه   &nbsp;
                                </label>
                                <br></br>
                                <EnumRadioInput enumObj={enumYesNo} value={model && model.BodyFrontProb} name="BodyFrontProb" ref="BodyFrontProb" onChange={this.refreshModel}></EnumRadioInput>
                            
                            </div>
                           </div>
                           <div className="col-md-6">
                           <div className="form-group">
                                <label>
                               توضیحات   &nbsp;
                                </label>
                                <input  className="form-control" value={model && model.BodyFrontProbDesc} ref="BodyFrontProbDesc"  name="BodyFrontProbDesc" onChange={this.refreshText} type="text" />      
                            </div>
                              
                           </div>
                        </div>

                        <div className="row">
                           <div className="col-md-6">
                           <div className="form-group">
                                <label>
                               خلف تنه   &nbsp;
                                </label>
                                <br></br>
                                <EnumRadioInput enumObj={enumYesNo} value={model && model.BodyBackProb} name="BodyBackProb" ref="BodyBackProb" onChange={this.refreshModel}></EnumRadioInput>
                            
                            </div>
                           </div>
                           <div className="col-md-6">
                           <div className="form-group">
                                <label>
                               توضیحات   &nbsp;
                                </label>
                                <input  className="form-control" value={model && model.BodyBackProbDesc} ref="BodyBackProbDesc"  name="BodyBackProbDesc" onChange={this.refreshText} type="text" />      
                            </div>
                              
                           </div>
                        </div>

                        <div className="row">
                           <div className="col-md-6">
                           <div className="form-group">
                                <label>
                               اندام های فوقانی   &nbsp;
                                </label>
                                <br></br>
                                <EnumRadioInput enumObj={enumYesNo} value={model && model.UpperOrganProb} name="UpperOrganProb" ref="UpperOrganProb" onChange={this.refreshModel}></EnumRadioInput>
                            
                            </div>
                           </div>
                           <div className="col-md-6">
                           <div className="form-group">
                                <label>
                               توضیحات   &nbsp;
                                </label>
                                <input  className="form-control" value={model && model.UpperOrganProbDesc} ref="UpperOrganProbDesc"  name="UpperOrganProbDesc" onChange={this.refreshText} type="text" />      
                            </div>
                              
                           </div>
                        </div>

                        <div className="row">
                           <div className="col-md-6">
                           <div className="form-group">
                                <label>
                               اندام های تحتانی   &nbsp;
                                </label>
                                <br></br>
                                <EnumRadioInput enumObj={enumYesNo} value={model && model.LowerOrganProb} name="LowerOrganProb" ref="LowerOrganProb" onChange={this.refreshModel}></EnumRadioInput>
                            
                            </div>
                           </div>
                           <div className="col-md-6">
                           <div className="form-group">
                                <label>
                               توضیحات   &nbsp;
                                </label>
                                <input  className="form-control" value={model && model.LowerOrganProbDesc} ref="LowerOrganProbDesc"  name="LowerOrganProbDesc" onChange={this.refreshText} type="text" />      
                            </div>
                              
                           </div>
                        </div>

                        <div className="row">
                           <div className="col-md-6">
                           <div className="form-group">
                                <label>
                               ناحیه تناسلی و مقعد   &nbsp;
                                </label>
                                <br></br>
                                <EnumRadioInput enumObj={enumYesNo} value={model && model.GenitalOrganProb} name="GenitalOrganProb" ref="GenitalOrganProb" onChange={this.refreshModel}></EnumRadioInput>
                            
                            </div>
                           </div>
                           <div className="col-md-6">
                           <div className="form-group">
                                <label>
                               توضیحات   &nbsp;
                                </label>
                                <input  className="form-control" value={model && model.GenitalOrganProbDesc} ref="GenitalOrganProbDesc"  name="GenitalOrganProbDesc" onChange={this.refreshText} type="text" />      
                            </div>
                              
                           </div>
                        </div>
                        
                        </fieldset>

                        <fieldset>
                            <legend>یافته های بیماری و توصیف آن</legend>

                            <div className="form-group">
                               
                                <input type="checkbox"   defaultChecked={model && model.Edema} ref="Edema"  name="Edema" onChange={this.handleCheckBox} />      
                                <label>
                                &nbsp; ادم   
                                </label>
                                &nbsp;&nbsp;
                                <input type="checkbox"   defaultChecked={model && model.DermProblem} ref="DermProblem"  name="DermProblem" onChange={this.handleCheckBox} />      
                                <label>
                                &nbsp; بثورات پوستی   
                                </label>
                                &nbsp;&nbsp;
                                <input type="checkbox"   defaultChecked={model && model.Yellowness} ref="Yellowness"  name="Yellowness" onChange={this.handleCheckBox} />      
                                <label>
                                &nbsp; زردی   
                                </label>
                                &nbsp;&nbsp;
                                <input type="checkbox"   defaultChecked={model && model.Cyanosis} ref="Cyanosis"  name="Cyanosis" onChange={this.handleCheckBox} />      
                                <label>
                                &nbsp; سیانوز   
                                </label>
                                &nbsp;&nbsp;
                                <input type="checkbox"   defaultChecked={model && model.Bedsore} ref="Bedsore"  name="Bedsore" onChange={this.handleCheckBox} />      
                                <label>
                                &nbsp; زخم بستر   
                                </label>

                                <div className="form-group">
                                    <label>
                                سایر   &nbsp;
                                    </label>
                                    <input  className="form-control" value={model && model.OtherClinicalFindings} ref="OtherClinicalFindings"  name="OtherClinicalFindings" onChange={this.refreshText} type="text" />      
                                </div>

                            </div>

                        </fieldset>

                        <fieldset>
                            <legend>پاراکلینیک</legend>

                            <div className="form-group">
                               
                                <input type="checkbox"   defaultChecked={model && model.Graphy} ref="Graphy"  name="Graphy" onChange={this.handleCheckBox} />      
                                <label>
                                &nbsp; گرافی   
                                </label>
                                &nbsp;&nbsp;
                                <input type="checkbox"   defaultChecked={model && model.Test} ref="Test"  name="Test" onChange={this.handleCheckBox} />      
                                <label>
                                &nbsp; آزمایش   
                                </label>
                                &nbsp;&nbsp;
                                <input type="checkbox"   defaultChecked={model && model.ECG} ref="ECG"  name="ECG" onChange={this.handleCheckBox} />      
                                <label>
                                &nbsp; نوارقلب   
                                </label>
                                &nbsp;&nbsp;
                                <input type="checkbox"   defaultChecked={model && model.CT} ref="CT"  name="CT" onChange={this.handleCheckBox} />      
                                <label>
                                &nbsp; سی تی اسکن   
                                </label>
                                &nbsp;&nbsp;
                                <input type="checkbox"   defaultChecked={model && model.MRI} ref="MRI"  name="MRI" onChange={this.handleCheckBox} />      
                                <label>
                                &nbsp;ام آر ای   
                                </label>

                                <div className="form-group">
                                    <label>
                                نتیجه   &nbsp;
                                    </label>
                                    <input  className="form-control" value={model && model.ParaClinicalFindingsResult} ref="ParaClinicalFindingsResult"  name="ParaClinicalFindingsResult" onChange={this.refreshText} type="text" />      
                                </div>

                            </div>

                        </fieldset>

                        <fieldset>
                            <legend>ارزیابی و نتیجه گیری</legend>

                                <div className="form-group">
                                    <label>
                                    ارزیابی و نتیجه گیری   &nbsp;
                                    </label>
                                    <input  className="form-control" value={model && model.FinalEvaluation} ref="FinalEvaluation"  name="FinalEvaluation" onChange={this.refreshText} type="text" />      
                                </div>
                                <div className="form-group">
                                    <label>
                                    نتیجه گیری   &nbsp;
                                    </label>
                                    <EnumRadioInput enumObj={enumFinalResult} value={model && model.FinalResult} name="FinalResult" ref="FinalResult" onChange={this.refreshModel}></EnumRadioInput>
                            
                                </div>
                                <div className="form-group">
                                    <label>
                                    علت فوت   &nbsp;
                                    </label>
                                    <input  className="form-control" value={model && model.DeathCause} ref="DeathCause"  name="DeathCause" onChange={this.refreshText} type="text" />      
                            
                                </div>

                        </fieldset>
                        
                       
                    </div>
                    
 
                            
                </div>
                

               
            </div>
  
        );
    }
}
 
export default CertReqMoralInspectionFormPartial;